import { useAtomValue } from 'jotai'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import { selectedMunicipalityIdAtom } from '@/state'
import MunicipalitiesLoader from '@/wrappers/municipalities-loader'
import BooleanLabel from '@/components/boolean-label'
import MunicipalityAdministrationSharingForm from '@/components/forms/municipality-administration-sharing'
import MunicipalityPermissionGate from '@/components/municipality-permission-gate'

function MunicipalitySettingsView() {

    const title = 'Nastavení obce'

    const municipalityId = useAtomValue(selectedMunicipalityIdAtom)

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper>
                <Box position="relative">
                    <Typography variant="h2" component="h1" mb={1.5}>
                        {title}
                    </Typography>
                    <MunicipalityPermissionGate>
                        <MunicipalitiesLoader>
                            {municipalities => {
                                const municipality = municipalities.find(item => item.id === municipalityId)
                                return municipality ? (
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 1.5,
                                        pt: 2,
                                    }}>
                                        <Box>
                                            <Typography variant="h5" component="h3">
                                                Viditelnost na veřejném portálu
                                            </Typography>
                                            <BooleanLabel bool={municipality.visible_on_public} />
                                        </Box>
                                        <Box>
                                            <Typography variant="h5" component="h3">
                                                Sdílení správy obce se svozovou společností
                                            </Typography>
                                            <BooleanLabel bool={municipality.is_visible_for_collection_company} />
                                        </Box>
                                        {municipality.set_is_visible_for_collection_company_by_municipality &&
                                            <Box sx={{
                                                display: 'flex',
                                            }}>
                                                <MunicipalityAdministrationSharingForm
                                                    municipalityId={municipalityId}
                                                    isVisibleForCollectionCompany={municipality.is_visible_for_collection_company}
                                                />
                                            </Box>
                                        }
                                    </Box>
                                ) : (
                                    <Box>
                                        Nastavení obce se nepodařilo načíst.
                                    </Box>
                                )
                            }}
                        </MunicipalitiesLoader>
                    </MunicipalityPermissionGate>
                </Box>
            </CustomPaper>
        </>
    )
}

export default MunicipalitySettingsView
